<template>
  <div></div>
</template>
<script>
// import md5 from 'js-md5';
export default {
  data() {
    return {};
  },
  mounted() {
    let data = this.$route.query;

    this.$axios
      .post("/api/pwdLogin", {
        type: 0,
        phone: data.phone,
        pwd: data.pwd
      })
      .then(res => {
        console.log(res);
        if (res.data.code == 200) {
          localStorage.setItem("token", JSON.stringify(res.data.data));
          setTimeout(() => {
            if (data.type == 1 || !data.type) {
              this.$router.push("/user/eval_jees/list");
            } else if (data.type == 2) {
              this.$router.push("/crm/index");
            } else if (data.type == 3) {
              this.$router.push("/user/grouping/list");
            }
          }, 1000);
        } else {
          this.$router.push("/");
        }
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/view/pwdLogin/index.vue